<template>
  <div class="wrap">
    <div class="header">
      <h4>如何提现【我的收益】</h4>
      <van-icon name="cross" size="20" @click="close"/>          
    </div>
    <div class="content">
      <p>请使用电脑端登录 <span class="text-blue">http://author.talkgk.com</span></p>
      <p>进行结算收益的提现以及更多功能体验。</p>
    </div>
  </div> 
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      url: process.env.VUE_APP_CMS_PC_author
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/index.scss';
</style>
